import { TalentStoreModel } from '@/types';
import scriptKoc from './scriptKoc';


const talent: TalentStoreModel = {
  scriptKoc,
};

export default talent;
